import styled from 'styled-components';

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  overflow-y: auto;
  padding: 8px 0;
  max-height: 400px;
  overflow-y: auto;
`;

export const ItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
  padding: 4px;
  border-radius: 4px;
  background-color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.colors.green2 : 'transparent'};
  cursor: pointer;
  color: ${({ $isSelected, theme }) => ($isSelected ? theme.colors.green7 : theme.colors.black9)};
  border: ${({ $isSelected, theme }) =>
    $isSelected ? `1px solid ${theme.colors.green7}` : 'none'};
  &:hover {
    background-color: ${({ theme }) => theme.colors.green1};
  }
`;

export const ItemTextWrapper = styled.div`
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  width: 100%;
`;
